<template>
  <div :class="['goal-list-status-chart']">
    <no-data v-if="!hasData" />
    <base-chart
      v-else
      :options="chartOptions"
    />
  </div>
</template>

<script setup>
import BaseChart from '@/components/dashboard/BaseChart.vue';
import NoData from '@/components/dashboard/NoData.vue';
import useStatusDistributionChart from '@/composables/grid-page/chart/status-distribution-chart';
import { DateTime } from 'luxon';
import { computed } from 'vue';

const props = defineProps({
  startDate: {
    type: Date,
    required: true,
  },
  endDate: {
    type: Date,
    required: true,
  },
  chartData: {
    type: Array,
    default: () => [],
  },
});

const chartResult = computed(() => ({
  statusDistributionData: props.chartData,
  startDate: DateTime.fromJSDate(props.startDate),
  endDate: DateTime.fromJSDate(props.endDate),
}));

const { chartOptions, hasData } = useStatusDistributionChart(chartResult, { showLegend: false });
</script>
